import { Building2, type LucideIcon } from 'lucide-react';

/**
 * A photo, or a placeholder when none has been uploaded yet.
 *
 * One component for the Properties list card, a property's hero, and a
 * unit's hero — all three are "show this thing's photo, or a neutral
 * placeholder" with nothing else to decide, so a size/aspect-ratio modifier
 * class is the only thing that varies between them (`.cover-image--card` /
 * `.cover-image--hero` in styles.css).
 */
export function CoverImage({
  src,
  alt,
  icon: Icon = Building2,
  variant,
}: {
  src: string | null;
  alt: string;
  icon?: LucideIcon;
  variant: 'card' | 'hero';
}) {
  return (
    <div className={`cover-image cover-image--${variant}`}>
      {src ? (
        <img src={src} alt={alt} />
      ) : (
        <Icon aria-hidden="true" strokeWidth={1.3} size={variant === 'hero' ? 64 : 40} />
      )}
    </div>
  );
}
